export const ACTIVESUBSCRIPTION = 'ACTIVESUBSCRIPTION';
export const SETACTIVESUBSCRIPTIONNULL = 'SETACTIVESUBSCRIPTIONNULL';
export const TOTALSUBSCRIPTIONS = 'TOTALSUBSCRIPTIONS';
export const SETTOTALSUBSCRIPTIONSNULL = 'SETTOTALSUBSCRIPTIONSNULL';
